import AppContentView from 'Components/Generic/AppContentView';
import { SITE_PAGES } from 'Config';
import PropTypes from 'prop-types';

const RequestLanding = ({
  title = '',
  titleButton,
  breadcrumbs = [],
  children,
}) => {
  let allBreadcrumbs = [SITE_PAGES.ORDER_LANDING, ...breadcrumbs];

  return (
    <AppContentView
      title={title}
      titleButton={titleButton}
      breadcrumbs={allBreadcrumbs}>
      {children}
    </AppContentView>
  );
};

RequestLanding.propTypes = {
  title: PropTypes.string,
  titleButton: PropTypes.node,
  breadcrumbs: PropTypes.array,
  children: PropTypes.node,
};

export default RequestLanding;
